import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAccountHierarchy as GetAccountHierarchyQuery,
    ParentChildFragment,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_HIERARCHY from '../queries/get-account-hierarchy.graphql';

export const useGetAccountHierarchy = (
    accountId: string
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    childAccounts: ParentChildFragment[];
    parentAccount: ParentChildFragment | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {
        data,
        loading: isLoading,
        error,
        refetch,
    } = useQuery<GetAccountHierarchyQuery, Record<any, any>>(GET_ACCOUNT_HIERARCHY, {
        variables: {
            id: accountId,
        },
    });

    const account = data ? data.account : null;
    const childAccounts =
        account && account.childAccounts
            ? account.childAccounts.edges.map((edge) => edge.node)
            : [];
    const parentAccount = account && account.parentAccount ? account.parentAccount : null;

    return {
        childAccounts,
        parentAccount,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
